const state = {
  loginVisible: false, // 登录注册弹窗
  userInfo: {}, // 用户信息，以 sessionStorage 为唯一持久化来源
  cartNum: 0 // 购物车商品数量
}

export default state
